import React from "react";
import AttendeeAvatar from "../attendeeList/AttendeeAvatar";
import LightTheme from "../theme/LightTheme";

interface Props {
  avatarUrl: string;
  name: string;
  title: string;
}

const SessionPresenterCard = ({ avatarUrl, name, title }: Props) => (
  <div className="presenterTag">
    <AttendeeAvatar name={name} url={avatarUrl} />
    <div className="titleWrapper">
      <div className="presenterName">{name}</div>
      <div className="presenterTitle">{title}</div>
    </div>
    <style jsx>{`
      .photo {
        height: 40px;
        width: 40px;
        background: ${LightTheme.gradientBackground};
        border-radius: 50%;
      }
      .presenterTag {
        padding: 0 20px 10px 0;
        display: flex;
      }
      .presenterTitle {
        font-weight: normal;
        font-size: 0.8rem;
        color: ${LightTheme.font.secondary.color};
      }
      .titleWrapper {
        padding: 0 0 0 13px;
      }
    `}</style>
  </div>
);

export default SessionPresenterCard;
